import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getSer } from '../../actions'
import { sidemenuFooterWrap } from "../componentCommon";
import "./PhotoSer.scss";
import { Link } from "react-router-dom";

const mapStateToProps = state => ({
    phSSer: state.phSer.phSSer,
  });
const mapDispatchToProps = dispatch => ({
    getSer: (payload) => dispatch(getSer(payload))
  });
  
let PhotoSer = ({ match, phSSer, getSer }) => {
    let serSlug = match.params.hasOwnProperty('serSlug') ? match.params.serSlug : '';

    useEffect(
        function() {
            // console.log('serSlug');
            // console.log(serSlug);            
          if (serSlug != '') {
            getSer({slug: serSlug});
          }             
        },
        [serSlug]
    );

    console.log('phSSer');
    console.log(phSSer);            

    let phLi = [];
    if (phSSer.hasOwnProperty('photos')) {
        phLi = phSSer.photos.map((ph, ind) => (
            <Link to={{ pathname: phSSer.imPGet(ph.name) }} target="_blank">
              <img  src={ phSSer.imPGet(ph.small) } key={'ph-' + ind} className="ph" />
            </Link>
            // <Row key={'ph-el-' + ind} className="ph-el">
            // </Row>
          )    
        );
        
    }
    
        
    return (

    <div>
        {phLi}
    </div>
    );
}

PhotoSer = sidemenuFooterWrap(PhotoSer);
export default connect(mapStateToProps, mapDispatchToProps)(PhotoSer);
